import { BaseApiClient } from './core';
import type { OnboardingPersonalizationRequest, OnboardingPersonalizationResponse, QuickSyncProgressResponse, QuickSyncTriggerRequest, QuickSyncTriggerResponse, WowMomentResponse } from '@/types/onboarding';

export class OnboardingApiClient extends BaseApiClient {
  // ============================================================================
  // Onboarding
  // ============================================================================

  async saveOnboardingPersonalization(
    request: OnboardingPersonalizationRequest
  ): Promise<OnboardingPersonalizationResponse> {
    const { data } = await this.client.post<OnboardingPersonalizationResponse>(
      '/onboarding/personalization',
      request
    );
    return data;
  }
  async triggerQuickSync(
    request: QuickSyncTriggerRequest
  ): Promise<QuickSyncTriggerResponse> {
    const { data } = await this.client.post<QuickSyncTriggerResponse>(
      '/onboarding/trigger-quick-sync',
      request
    );
    return data;
  }
  async getQuickSyncProgress(orgId: string): Promise<QuickSyncProgressResponse> {
    const { data } = await this.client.get<QuickSyncProgressResponse>(
      `/onboarding/quick-sync-progress/${orgId}`
    );
    return data;
  }
  async getWowMomentInsights(orgId: string): Promise<WowMomentResponse> {
    const { data } = await this.client.get<WowMomentResponse>(
      `/onboarding/wow-moment/${orgId}`
    );
    return data;
  }
  // Onboarding tracking
  async trackOnboardingStep(step: string, stepNumber: number, metadata?: Record<string, unknown>): Promise<void> {
    await this.client.post('/onboarding/track-step', { step, step_number: stepNumber, metadata });
  }
  async sendHeartbeat(page: string): Promise<{ session_id: string }> {
    const { data } = await this.client.post<{ session_id: string }>('/onboarding/heartbeat', { page });
    return data;
  }
  async sendDesktopSetupLink(email: string): Promise<{ sent: boolean }> {
    const { data } = await this.client.post<{ sent: boolean }>('/onboarding/send-desktop-link', { email });
    return data;
  }
}

export const onboardingApi = new OnboardingApiClient();
